<template>
    <b-modal
        id="create-group-custom-editor-file"
        v-model="modal"
        ref="create-group-custom-editor-file"
        size="md"
        :title="$t('group.add_extra_work_file')"
        modal-class="apprentice-default-modal"
        :ok-title="$t('common.save')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk">
        <b-form-group
            :label="$t('common.name') + ':'"
            label-for="group-custom-editor-file-name-input">
            <b-form-input
                id="group-custom-editor-file-name-input"
                v-model="name">
            </b-form-input>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-create-group-custom-editor-file-modal-component',
    props: {
        groupIn: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            name: '',
            modal: false,
        };
    },
    methods: {
        show() {
            this.name = '';
            this.modal = true;
        },
        onOk() {
            let data = {
                group_id: this.groupIn.id,
                name: this.name,
            };

            this.axios.post(this.routes.storeGroupCustomEditorFile(this.groupIn.id), data).then(
                (response) => {
                    this.$emit('GroupCustomEditorFileCreated', response.data);
                    this.modal = false;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss"></style>
